import { phoneExtItemService } from '@/services/api/phoneExtItem.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { phoneExtItemModel } from '@/models/api/phoneExtItem.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    listByDepartment: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PHONE_EXT_ITEM_MODULE = "api/phoneExtItem";

// ACTIONS
export const GET_ALL_PHONE_EXT_ITEM = 'getAllPhoneExtItem';
export const CREATE_PHONE_EXT_ITEM = 'createPhoneExtItem';
export const GET_PHONE_EXT_ITEM = 'getPhoneExtItem';
export const UPDATE_PHONE_EXT_ITEM = 'updatePhoneExtItem';
export const UPDATE_PHONE_EXT_ITEM_STATUS = 'updatePhoneExtItemStatus';
export const UPDATE_PHONE_EXT_ITEM_SEQUENCE = 'updatePhoneExtItemSequence';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PHONE_EXT_ITEM_SUCCESS = "allPhoneExtItemSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PHONE_EXT_ITEM_SUCCESS = "getPhoneExtItemSuccess";

export const actions = {
    [GET_ALL_PHONE_EXT_ITEM]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return phoneExtItemService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PHONE_EXT_ITEM_SUCCESS, {data: result, filter});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_ITEM_SEQUENCE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtItemService
            .updateSequence(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('label.sequence')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [CREATE_PHONE_EXT_ITEM]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtItemService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PHONE_EXT_ITEM]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return phoneExtItemService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PHONE_EXT_ITEM_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_ITEM]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtItemService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PHONE_EXT_ITEM_STATUS]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtItemService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PHONE_EXT_ITEM_SUCCESS](state, {data, filter}) {
        const groups = data.success ? (data.data || [])
            .map(item => phoneExtItemModel(item))
            .filter(item => item.isActive)
            .sort((a, b) => (a.sequence || 0) - (b.sequence || 0)) : [];
        state.listByDepartment = { ...state.listByDepartment, [filter.phoneExtDepartmentUuid]: groups };
    },
    setPhoneExtItemByDepartment(state, {phoneExtDepartmentUuid, data}) {
        state.listByDepartment = { ...state.listByDepartment, [phoneExtDepartmentUuid]: data };
    },
    [GET_PHONE_EXT_ITEM_SUCCESS](state, data) {
        state.details = phoneExtItemModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

